// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VhxNy","sub":"styles_sub__dPHY5","topLabel":"styles_topLabel__LrOx6","topLabelVal":"styles_topLabelVal__+qZ6l"};